export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.filter((r) => r.scope.endsWith('/assets/other/')).forEach((r) => r.unregister()));
      navigator.serviceWorker
        .register('/service-worker.js', { updateViaCache: 'none' })
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration.scope);

          // Send API URLs to service worker. Frontend-facing endpoints have been migrated
          // to admin-backend, so use the Gossamer origin for both channels.
          const adminApiUrl = process.env.GOSSAMER_BE_ORIGIN || 'http://localhost:3000';
          const mainApiUrl = adminApiUrl;
          navigator.serviceWorker.ready.then((reg) => {
            reg.active?.postMessage({
              type: 'SET_API_URLS',
              mainApiUrl,
              adminApiUrl,
            });
            console.log('[SW Registration] Sent API URLs to service worker:', { mainApiUrl, adminApiUrl });
          });
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('Error unregistering service worker:', error);
      });
  }
}
